import { ProductName } from '@pypestream/api-services';
import { TranslationKeys } from './types';

/**
 * The two mappers below are keyed by `ProductName`, a GraphQL enum generated
 * from whichever schema the build runs against. The candidate schema's enum has
 * no `MaestroStudio` member (checked 2026-10-26: four members), while a schema
 * that does have it requires an entry for it. Naming
 * `ProductName.MaestroStudio` therefore fails the type check wherever the
 * member is absent, and the manager deploy to candidate failed on exactly that.
 *
 * So the Maestro Studio entry is written under its wire value
 * (`MAESTRO_STUDIO`) in a plain object, and the exported mapper is that object
 * assigned to the `ProductName`-keyed type. A variable is not checked for
 * excess properties, so the extra key is accepted where the enum lacks the
 * member, and where the enum has it the same key satisfies the required entry.
 * `as const` keeps the values as literals so they stay assignable to
 * `TranslationKeys`.
 */
const toolsTranslations = {
  [ProductName.Organization]: 'manager/common:products.manager',
  [ProductName.AgentAssist]: 'manager/common:products.agentAssist',
  [ProductName.Analytics]: 'manager/common:products.analytics',
  [ProductName.ProStudio]: 'manager/common:products.proStudio',
  MAESTRO_STUDIO: 'manager/common:products.maestroStudio',
} as const;

const toolsDescriptionTranslations = {
  [ProductName.Organization]: 'manager/common:products.managerDescription',
  [ProductName.AgentAssist]: 'manager/common:products.agentAssistDescription',
  [ProductName.Analytics]: 'manager/common:products.analyticsDescription',
  [ProductName.ProStudio]: 'manager/common:products.proStudioDescription',
  MAESTRO_STUDIO: 'manager/common:products.maestroStudioDescription',
} as const;

export const ToolsTranslationMapper: {
  [key in ProductName]: TranslationKeys;
} = toolsTranslations;

export const ToolsDescriptionTranslationMapper: {
  [key in ProductName]: TranslationKeys;
} = toolsDescriptionTranslations;
